(() => {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => [...root.querySelectorAll(selector)];
  const body = document.body;
  const toast = qs('#ThemeToast');
  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

  const formatMoney = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: body.dataset.currency || 'INR' }).format(cents / 100); }
    catch (_) { return `₹${Math.round(cents / 100)}`; }
  };
  const notify = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toast._timer);
    toast._timer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };
  const trapEscape = (event) => {
    if (event.key !== 'Escape') return;
    closeCart();
    closeMobileMenu();
  };

  const cartDrawer = qs('[data-cart-drawer]');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.hidden = false;
    requestAnimationFrame(() => cartDrawer.classList.add('is-open'));
    body.classList.add('drawer-open');
    qsa('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'true'));
    qs('[data-cart-close]', cartDrawer)?.focus();
  };
  const closeCart = () => {
    if (!cartDrawer || cartDrawer.hidden) return;
    cartDrawer.classList.remove('is-open');
    body.classList.remove('drawer-open');
    qsa('[data-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    window.setTimeout(() => { cartDrawer.hidden = true; }, 220);
  };

  const renderCart = (cart) => {
    qsa('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; if (el.hasAttribute('data-cart-count-badge')) el.hidden = cart.item_count === 0; });
    qsa('[data-cart-total]').forEach((el) => { el.textContent = formatMoney(cart.total_price); });
    qsa('[data-cart-open]').forEach((button) => button.setAttribute('aria-label', `Open cart with ${cart.item_count} items`));
    const subtotal = qs('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    const items = qs('[data-cart-items]');
    if (items) {
      items.innerHTML = cart.items.length ? cart.items.map((item) => `
        <article class="drawer-line" data-line-key="${escapeHTML(item.key)}">
          ${item.image ? `<a href="${escapeHTML(item.url)}"><img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.featured_image?.alt || item.product_title || '')}" width="74" height="74" loading="lazy"></a>` : ''}
          <div class="drawer-line__info"><a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.product_title)}</strong></a>${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHTML(item.variant_title)}</p>` : ''}<div class="drawer-line__bottom"><div class="drawer-line__actions"><button type="button" class="drawer-line__remove" data-cart-remove="${escapeHTML(item.key)}" aria-label="${escapeHTML(cartDrawer?.dataset.cartRemoveLabel || 'Remove item')}: ${escapeHTML(item.product_title)}"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 10v7m4-7v7"/></svg></button><div class="cart-qty"><button type="button" data-cart-quantity="${item.quantity - 1}" data-cart-key="${escapeHTML(item.key)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity + 1}" data-cart-key="${escapeHTML(item.key)}" aria-label="Increase quantity">+</button></div></div><div class="drawer-line__price"><strong>${formatMoney(item.final_line_price)}</strong>${Number(item.original_line_price) > Number(item.final_line_price) ? `<s aria-label="${escapeHTML(cartDrawer?.dataset.cartOriginalPriceLabel || 'Before discounts')}">${formatMoney(item.original_line_price)}</s>` : ''}</div></div></div>
        </article>`).join('') : '<div class="empty-state empty-state--compact"><h3>Your cart is empty</h3><p>Add something useful for your pet.</p></div>';
    }
    document.dispatchEvent(new CustomEvent('paw:cart-updated', { detail: cart }));
    setCartBusy();
  };
  let cartQueue = Promise.resolve();
  let pendingCartTasks = 0;
  const lockedCartControls = new Map();
  const setCartBusy = () => {
    if (pendingCartTasks) {
      qsa('[data-cart-quantity], [data-cart-remove], [data-upsell-add], [data-coupon-quick], [data-coupon-apply], [data-coupon-clear], .cart-drawer [name="checkout"], .cart-page [name="checkout"]').forEach(control => {
        if (!lockedCartControls.has(control)) lockedCartControls.set(control, control.disabled);
        control.disabled = true;
      });
    } else {
      lockedCartControls.forEach((disabled, control) => { if (control.isConnected) control.disabled = disabled; });
      lockedCartControls.clear();
    }
  };
  const runCartTask = task => {
    pendingCartTasks++;
    setCartBusy();
    const result = cartQueue.then(() => task(readCart));
    cartQueue = result.catch(() => {});
    return result.finally(() => { pendingCartTasks--; setCartBusy(); });
  };
  const readCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  };
  const refreshCart = () => runCartTask(readCart);
  const changeCart = (key, quantity) => runCartTask(async () => {
    if (!key || !Number.isSafeInteger(quantity) || quantity < 0) throw new Error('Invalid cart quantity');
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    if (!response.ok) throw new Error('Unable to update cart');
    renderCart(await response.json());
  });

  window.PawCart = { refresh: refreshCart, mutate: runCartTask, open: openCart };

  const mobileMenu = qs('[data-mobile-menu]');
  const ensureMobileNav = () => {
    const container = qs('[data-mobile-nav]', mobileMenu);
    if (!container || container.children.length > 0) return;
    const desktopItems = qsa('.desktop-nav .desktop-nav__item');
    if (!desktopItems.length) return;

    desktopItems.forEach(item => {
      const mainLink = qs(':scope > a', item);
      if (!mainLink) return;
      const url = mainLink.getAttribute('href');
      const text = mainLink.textContent.trim().toLowerCase();
      const isDirect = !item.classList.contains('has-dropdown') || text === 'humans' || text.includes('rent a villa');

      if (isDirect) {
        const div = document.createElement('div');
        div.className = 'mobile-nav-item';
        div.innerHTML = `<a class="mobile-nav-direct" href="${url}">${mainLink.innerHTML}</a>`;
        container.appendChild(div);
        return;
      }

      const details = document.createElement('details');
      details.className = 'mobile-nav-item';
      if (mainLink.hasAttribute('aria-current')) details.open = true;

      const summary = document.createElement('summary');
      summary.innerHTML = `<a href="${url}">${mainLink.innerHTML}</a><span>+</span>`;
      details.appendChild(summary);

      const childrenDiv = document.createElement('div');
      childrenDiv.className = 'mobile-nav-children';

      if (item.classList.contains('nav--mega')) {
        const groupsDiv = document.createElement('div');
        groupsDiv.className = 'paw-mobile-groups';
        qsa('.nav-dropdown__column', item).forEach(col => {
          const group = document.createElement('div');
          group.className = 'paw-mobile-group';
          group.innerHTML = col.innerHTML;
          groupsDiv.appendChild(group);
        });
        childrenDiv.appendChild(groupsDiv);
      } else {
        qsa('.paw-compact-links > li', item).forEach(li => {
          const childLink = qs(':scope > a', li);
          if (childLink) {
            const a = document.createElement('a');
            a.href = childLink.getAttribute('href');
            a.textContent = childLink.textContent.trim();
            childrenDiv.appendChild(a);
          }
          qsa(':scope > ul a', li).forEach(grandLink => {
            const a = document.createElement('a');
            a.className = 'mobile-nav-grandchild';
            a.href = grandLink.getAttribute('href');
            a.textContent = grandLink.textContent.trim();
            childrenDiv.appendChild(a);
          });
        });
      }

      details.appendChild(childrenDiv);
      container.appendChild(details);
    });
  };
  qs('[data-mobile-menu-open]')?.addEventListener('pointerenter', ensureMobileNav, { passive: true, once: true });
  qs('[data-mobile-menu-open]')?.addEventListener('touchstart', ensureMobileNav, { passive: true, once: true });

  const openMobileMenu = () => {
    if (!mobileMenu) return;
    ensureMobileNav();
    mobileMenu.hidden = false;
    requestAnimationFrame(() => mobileMenu.classList.add('is-open'));
    body.classList.add('drawer-open');
    qs('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'true');
    qs('[data-mobile-menu-close]', mobileMenu)?.focus();
  };
  const closeMobileMenu = () => {
    if (!mobileMenu || mobileMenu.hidden) return;
    mobileMenu.classList.remove('is-open');
    body.classList.remove('drawer-open');
    qs('[data-mobile-menu-open]')?.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => { mobileMenu.hidden = true; }, 220);
  };

  const initHeroes = () => qsa('[data-hero-carousel]').forEach((carousel) => {
    const slides = qsa('[data-hero-slide]', carousel);
    const dots = qsa('[data-hero-dot]', carousel);
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    let request = 0;
    const prepare = async (slide) => {
      const image = qs('img', slide);
      if (!image) return true;
      image.loading = 'eager';
      if (!image.complete) {
        await new Promise(resolve => {
          const done = () => { image.removeEventListener('load', done); image.removeEventListener('error', done); resolve(); };
          image.addEventListener('load', done, {once: true});
          image.addEventListener('error', done, {once: true});
        });
      }
      if (!image.naturalWidth) return false;
      if (image.decode) { try { await image.decode(); } catch (_) {} }
      return true;
    };
    const show = async (next) => {
      const target = (next + slides.length) % slides.length;
      const currentRequest = ++request;
      if (!await prepare(slides[target]) || currentRequest !== request) return;
      index = target;
      slides.forEach((slide, i) => { slide.classList.toggle('is-active', i === index); slide.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
      dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
      prepare(slides[(index + 1) % slides.length]);
    };
    const start = () => {
      window.clearInterval(timer);
      if (carousel.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = window.setInterval(() => show(index + 1), Number(carousel.dataset.delay || 5000));
    };
    const restart = () => { window.clearInterval(timer); start(); };
    qs('[data-hero-prev]', carousel)?.addEventListener('click', () => { show(index - 1); restart(); });
    qs('[data-hero-next]', carousel)?.addEventListener('click', () => { show(index + 1); restart(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); restart(); }));
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', start);
    prepare(slides[1]);
    start();
  });

  const initProduct = () => qsa('[data-product-root]').forEach((root) => {
    if (root.matches('.paw-pdp')) return;
    const json = qs('[data-product-json]', root);
    const variants = json ? JSON.parse(json.textContent) : [];
    const form = qs('[data-product-form]', root);
    const variantInput = qs('[data-variant-id]', form);
    const submit = qs('[data-add-to-cart]', form);
    const addLabel = qs('[data-add-label]', form);
    const price = qs('[data-product-price]', root);
    const updateVariant = () => {
      const values = qsa('.product-option input:checked', form).map((input) => input.value);
      const variant = variants.find((entry) => entry.options.every((option, i) => option === values[i]));
      if (!variant) { submit.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      variantInput.value = variant.id;
      submit.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      price.innerHTML = `<strong>${formatMoney(variant.price)}</strong>${variant.compare_at_price > variant.price ? `<s>${formatMoney(variant.compare_at_price)}</s>` : ''}`;
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
    };
    qsa('.product-option input', form).forEach((input) => input.addEventListener('change', (event) => { event.target.closest('fieldset').querySelector('[data-option-label]').textContent = event.target.value; updateVariant(); }));
    qsa('[data-product-thumb]', root).forEach((thumb) => thumb.addEventListener('click', () => { const image = qs('[data-product-main-image]', root); if (image) { image.removeAttribute('srcset'); image.src = thumb.dataset.imageSrc; } qsa('[data-product-thumb]', root).forEach((item) => item.classList.remove('is-active')); thumb.classList.add('is-active'); }));
    qs('[data-quantity-minus]', form)?.addEventListener('click', () => { const input = qs('[name="quantity"]', form); input.value = Math.max(1, Number(input.value) - 1); });
    qs('[data-quantity-plus]', form)?.addEventListener('click', () => { const input = qs('[name="quantity"]', form); input.value = Number(input.value) + 1; });
  });

  const loadRecommendations = () => qsa('[data-product-recommendations]').forEach(async (section) => {
    if (section.innerHTML.trim()) return;
    try { const response = await fetch(section.dataset.url); const html = await response.text(); const doc = new DOMParser().parseFromString(html, 'text/html'); const replacement = qs('[data-product-recommendations]', doc); if (replacement?.innerHTML.trim()) section.innerHTML = replacement.innerHTML; } catch (_) {}
  });

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-cart-open]')) openCart();
    if (event.target.closest('[data-cart-close]')) closeCart();
    if (event.target.closest('[data-mobile-menu-open]')) openMobileMenu();
    if (event.target.closest('[data-mobile-menu-close]')) closeMobileMenu();
    const quantity = event.target.closest('[data-cart-quantity]');
    if (quantity) {
      quantity.disabled = true;
      try { await changeCart(quantity.dataset.cartKey, Number(quantity.dataset.cartQuantity)); }
      catch (_) { notify('Could not update the cart. Please try again.'); quantity.disabled = false; }
    }
    const remove = event.target.closest('[data-cart-remove]');
    if (remove) { remove.disabled = true; try { await changeCart(remove.dataset.cartRemove, 0); } catch (_) { notify('Could not update the cart. Please try again.'); remove.disabled = false; } }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.elements.id?.value || form.dataset.variantAvailable === 'false') { notify(form.dataset.unavailableLabel || 'Choose available options.'); return; }
    const payload = new FormData(form);
    const button = qs('[type="submit"]', form);
    if (button?.disabled) return;
    if (button) button.disabled = true;
    try {
      await runCartTask(async refresh => {
        const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: payload });
        if (!response.ok) throw new Error('Unable to add product');
        await refresh();
      });
      openCart();
      notify('Added to cart');
    } catch (_) { notify('Could not add this item. Please try again.'); }
    finally { if (button) button.disabled = form.dataset.variantAvailable === 'false'; }
  });
  qsa('[data-sort-select]').forEach((select) => select.addEventListener('change', () => { const url = new URL(window.location.href); url.searchParams.set('sort_by', select.value); window.location.assign(url.toString()); }));
  document.addEventListener('keydown', trapEscape);
  initHeroes();
  initProduct();
  loadRecommendations();
})();

